import React, {useState} from 'react';
import PropTypes from 'prop-types';
import WmsMobileLayout from "../../../wmsMobileLayout";
import {Card, CardContent, Grid, Paper, TableBody, TableCell, TableContainer, TableHead} from "@mui/material";
import PageTitle from "../../../../../components/WMS/Mobile/PageTitle";
import {FormattedMessage} from "react-intl";
import CustomButton from "../../../../../components/CustomButton";
import DeleteAssociationModal from "../Desktop/component/DeleteAssociationModal";
import Table from "../../../../../components/WMS/List/Table";
import TableRowHead from "../../../../../components/WMS/List/TableRowHead";
import TableCellHead from "../../../../../components/WMS/List/TableCellHead";
import TableRow from "../../../../../components/WMS/List/TableRow";
import {getTranslation} from "../../../../../domain/helpers/translations";
import EditIcon from "../../../../../components/icons/EditIcon";
import {greyishBlue500} from "../../../../../assets/jss/main";
import TrashIcon from "../../../../../components/icons/TrashIcon";
import Pagination from "../../../../../components/WMS/List/Pagination";
import AssociationDrawer from "./component/AssociationDrawer";
import Toast from "../../../../../components/WMS/Toast";
import ValidatedIcon from "assets/img/validated.svg";
import DeleteIcon from "assets/img/error.svg";
import useIsMobile from "hooks/useIsMobile";

AssociationMobile.propTypes = {
    associationList: PropTypes.array.isRequired,
    forceReload: PropTypes.func.isRequired
};

function AssociationMobile({associationList, forceReload}) {
    const isMobile = useIsMobile()

    const [openModal, setOpenModal] = useState(false)
    const [openDeleteModal, setOpenDeleteModal] = useState(false)
    const [openModifyModal, setOpenModifyModal] = useState(false)
    const [displayPage, setDisplayPage] = useState(1)

    const [openToast, setOpenToast] = useState(false)
    const [openDeleteToast, setOpenDeleteToast] = useState(false)
    const [openModifyToast, setOpenModifyToast] = useState(false)

    const [selectedAssociation, setSelectedAssociation] = useState()

    const handleCloseModal = (reload = false, operation = '') => {
        setOpenModal(false)
        setOpenDeleteModal(false)
        setOpenModifyModal(false)
        setSelectedAssociation(null)

        if ('create' === operation) {
            setOpenToast(true)
        }

        if ('delete' === operation) {
            setOpenDeleteToast(true)
        }

        if ('modify' === operation) {
            setOpenModifyToast(true)
        }

        if (reload) {
            forceReload()
        }
    }

    const handleDelete = (association) => {
        setOpenDeleteModal(true)
        setSelectedAssociation(association)
    }

    const vhToPx = (vh) => {
        return (window.innerHeight * vh) / 100
    }

    const handleModify = (association) => {
        setOpenModifyModal(true)
        setSelectedAssociation(association)
    }

    const handlePreviousPage = () => {
        if (displayPage > 0) {
            setDisplayPage(prev => prev - 1)
        }
    }

    const handleNextPage = () => {
        if (displayPage < associationList.totalPageCount - 1) {
            setDisplayPage(prev => prev + 1)
        }
    }

    const handlePageChange = (page) => {
        setDisplayPage(page - 1)
        forceReload(page)
    }
    return (
        <WmsMobileLayout>
            <WmsMobileLayout.LeftHeader></WmsMobileLayout.LeftHeader>
            <WmsMobileLayout.RightHeader></WmsMobileLayout.RightHeader>
            <WmsMobileLayout.Content>
                {openToast && (
                    <Toast
                        open={openToast}
                        handleClose={() => setOpenToast(false)}
                        isDesktop={!isMobile}
                        isTop={!isMobile}
                        customTimeout={2000}
                        icon={<img style={{height: '20px', width: '20px'}} src={ValidatedIcon} alt={"validated-icon"}/>}
                        title={<FormattedMessage id={"wms.associations.validationToast.title"}/>}
                    />
                )}

                {openDeleteToast && (
                    <Toast
                        open={openDeleteToast}
                        handleClose={() => setOpenDeleteToast(false)}
                        isDesktop={!isMobile}
                        isTop={!isMobile}
                        customTimeout={2000}
                        icon={<img style={{height: '20px', width: '20px'}} src={DeleteIcon} alt={"validated-icon"}/>}
                        title={<FormattedMessage id={"wms.associations.deleteToast.title"}/>}
                    />
                )}

                {openModifyToast && (
                    <Toast
                        open={openModifyToast}
                        handleClose={() => setOpenModifyToast(false)}
                        isDesktop={!isMobile}
                        isTop={!isMobile}
                        customTimeout={2000}
                        icon={<img style={{height: '20px', width: '20px'}} src={ValidatedIcon} alt={"validated-icon"}/>}
                        title={<FormattedMessage id={"wms.associations.modifyToast.title"}/>}
                    />
                )}

                <PageTitle
                    title={<FormattedMessage id={"wms.associations.title"}/>}
                    subtitle={<FormattedMessage id={"wms.associations.subtitle"}/>}
                />
                <Card>
                    <CardContent>
                        <Grid container direction={"column"} gap={"48px"}>
                            <div style={{
                                paddingTop: '8px',
                                width: '100%'
                            }}>
                                <CustomButton thicker fullWidth onClick={() => setOpenModal(true)}><FormattedMessage
                                    id={"wms.associations.buttonLabel.add.association"}/></CustomButton>
                            </div>

                            {(openModal || openModifyModal) && (
                                    <AssociationDrawer
                                        open={openModal === true ? openModal : openModifyModal}
                                        handleClose={handleCloseModal}
                                        association={openModifyModal ? selectedAssociation : null}
                                    />
                            )}

                            {openDeleteModal && (
                                <DeleteAssociationModal
                                    open={openDeleteModal}
                                    handleClose={handleCloseModal}
                                    association={selectedAssociation}
                                />
                            )}
                                <Paper sx={{width: '100%', overflow: 'hidden'}}>
                                    <TableContainer sx={{maxHeight: vhToPx(55)}}>
                                        <Table stickyHeader>
                                            <TableHead>
                                                <TableRowHead isDesktop>
                                                    {[
                                                        <FormattedMessage id={"wms.associations.tableHead.label.brand"}/>,
                                                        <FormattedMessage id={"wms.associations.tableHead.label.seller"}/>,
                                                        <FormattedMessage id={"wms.associations.tableHead.label.category"}/>,
                                                        <FormattedMessage id={"wms.associations.tableHead.label.firstPlace"}/>,
                                                        <FormattedMessage id={"wms.associations.tableHead.label.secondPlace"}/>,
                                                        <FormattedMessage id={"wms.associations.tableHead.label.action"}/>,
                                                    ].map((column) => (
                                                        <TableCellHead key={column}>
                                                            {column}
                                                        </TableCellHead>
                                                    ))}
                                                </TableRowHead>
                                            </TableHead>
                                            <TableBody>
                                                {associationList.items && associationList.items.length > 0 && associationList.items.map((association) => {
                                                    return (
                                                        <TableRow>
                                                            <TableCell>
                                                                {association.brand?.name}
                                                            </TableCell>
                                                            <TableCell>
                                                                {association.seller?.name}
                                                            </TableCell>
                                                            <TableCell>
                                                                {association.category ? getTranslation(association.category)?.name : null}
                                                            </TableCell>
                                                            <TableCell>
                                                                {association.firstPlace.name}
                                                            </TableCell>
                                                            <TableCell>
                                                                {association.secondPlace?.name}
                                                            </TableCell>
                                                            <TableCell>
                                                                <Grid container gap={"8px"} alignContent={"end"}>
                                                                    <EditIcon
                                                                        color={greyishBlue500}
                                                                        size={"16px"}
                                                                        onClick={() => handleModify(association)}
                                                                    />
                                                                    <TrashIcon
                                                                        color={greyishBlue500}
                                                                        size={"16px"}
                                                                        onClick={() => handleDelete(association)}
                                                                    />
                                                                </Grid>
                                                            </TableCell>
                                                        </TableRow>
                                                    )
                                                })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Paper>
                            <Grid justifyContent={'center'} sx={{maxWidth: "100%"}}>
                                <Pagination
                                    pageCount={associationList && associationList.totalPageCount}
                                    onClickPrevious={() => handlePreviousPage()}
                                    onClickNext={() => handleNextPage()}
                                    handlePageChange={(page) => handlePageChange(page)}
                                />
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </WmsMobileLayout.Content>
        </WmsMobileLayout>
    );
}

export default AssociationMobile;